export const InteractiveCourseware = {
    "有疑问":"有疑问",
    "有提问":"有提问",
    "学习开始时间":"学习开始时间",
    "学习已开始":"学习已开始",
    "是否结束发布":"是否结束发布",
    "结束发布后学生将无法进入本课件学习":"结束发布后,学生将无法进入本课件学习",
    "学习页面":"学习页面",
    "疑问数":"疑问数",
    "评论数":"评论数",
    "学习时间":"学习时间",
    "更换":"更换",
    "课件标题":"课件标题",
    "活动类型标签":"活动类型标签",
    "课件内容":"课件内容",
    "增加内容分段":"增加内容分段",
    "允许作答试题":"允许作答试题",
    "允许下载":"允许下载",
    "不允许下载":"不允许下载",
    "总分":"总分",
    "截止时间":"截止时间",
    "请选择章节目录":"请选择章节目录",
    "系统检测到您的当前设备暂不支持全屏模式":"系统检测到您的当前设备暂不支持全屏模式",
    "没有下一页了":"没有下一页了",
    "当前是第一页":"当前是第一页",
    "页的讨论":"页的讨论",
    "是否删除该评论":"是否删除该评论？",
    "批阅互动答题":"批阅互动答题",
    "试题分析":"试题分析",
    "互动批阅":"互动批阅",
    "您共学习了":"您共学习了",
    "页这是最后一页是否标记为已完成学习":"页，这是最后一页，是否标记为“已完成学习”？",
    "此课件为空点击返回":"此课件为空，点击返回",
    "老师已收到疑问":"老师已收到疑问",
    "有疑问学生":"有疑问学生",
    "课件学习":"课件学习",
    "学习统计":"学习统计",

}